import Vue from "vue";
import App from "./App.vue";
import "babel-polyfill";
import "./assets/js/global";
import BaiduMap from "vue-baidu-map";
import ElementUI from "element-ui";
import router from "./router";
import JsonExcel from "vue-json-excel";
import {
    checkCode
} from "@/assets/js/utils";


//放大图片
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

// 自定义全局样式
import "./assets/css/element-variables.scss";
import "./assets/css/index.scss";
// import "./assets/fonts/iconfont.css";

//自定义全局组件
import PageMain from "@/components/page/page-main";
import PageSub from "@/components/page/page-sub";
import PagingDefault from "@/components/paging/paging-default";
import UploadPhoto from "@/components/upload/upload-photo";
import UploadExcel from "@/components/upload/upload-excel";
import UploadList from "@/components/upload/upload-list";

// Vue.filter('th', function (url) {
//   return url + '?x-oss-process=style/th'
// })
Vue.filter("toFixed", function(value, d) {
    // console.log(value)
    if (value !== null) {
        if (d) {
            let regText = "\\B(?=(\\w{" + 3 + "})+(?!\\w))";
            let reg = new RegExp(regText, "g");
            return String(value.toFixed(d)).replace(reg, ",");
        }
        let regText = "\\B(?=(\\w{" + 3 + "})+(?!\\w))";
        let reg = new RegExp(regText, "g");
        return String(value.toFixed(2)).replace(reg, ",");
    }
});
const Directives = {
    install(Vue) {
        Vue.directive("auth", {
            // v-auth="'B_ALARMRULEMANAGEMENT_QUERY'"
            inserted(el, binding) {
                if (checkCode(binding.value)) {
                    el.style.display = "none";
                }
            }
        });
    }
};
Vue.use(Directives);
Vue.use(Viewer);
// 这里是插件的默认设置
Viewer.setDefaults({
    zIndexInline: 9999,
    zIndex: 9999,
    inline: false,
    button: true,
    navbar: false,
    title: false,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: false,
    transition: true,
    fullscreen: true,
    keyboard: true
});

Vue.component("page-main", PageMain);
Vue.component("page-sub", PageSub);
Vue.component("paging-default", PagingDefault);
Vue.component("upload-photo", UploadPhoto);
Vue.component("upload-excel", UploadExcel);
Vue.component("downloadExcel", JsonExcel);
Vue.component("upload-list", UploadList);

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: "oPmwIbYEat0l3mtFHGNKVffqptoqhnAH"
});
new Vue({
    router,
    render: h => h(App),
    data: {
        newsNum: 0 //未读消息数
    }
}).$mount("#app");


// WEBPACK FOOTER //
// ./src/main.js